// extracted by mini-css-extract-plugin
module.exports = {"rc-tabs-bar":"_2XkqH","rc-tabs-tab-active":"F1ZLq","input-suffix":"HMjcj","nav-item":"pn-Pk"};